import React, { useEffect } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import profile from '../../assets/img/profile.jpeg'
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

function HeaderNav() {
    let navigate = useNavigate()
    const userName = useSelector((user) => user.user.info.customer_full_heading)
    const section = useSelector((user) => user.settings.section)
    const userNameWords = userName.split(' ').length;
    const splittedName = userNameWords < 3 ? userName.split(' ').slice(0, -1).join(' ') : userName.split(' ').slice(0, -2).join(' ')
    const splittedNameLower = splittedName.toLowerCase()
    useEffect(() => {
    }, []);

    // const handleNav = () => {
    //     handleMenu();
    //     section ? navigate('/enrica/gas/profilo') : navigate('/enrica/profilo')
    // }
    return (
        <div className="headerNav">
            <div className="img">
                <img src={`https://avatars.dicebear.com/api/initials/${userName}.svg`} alt="foto profilo" />
            </div>
            <div className="text">
                <h2 className="title">Ciao {splittedNameLower}</h2>
                <p className="subTitle" onClick={() => section ? navigate('/enrica/gas/profilo') : navigate('/enrica/profilo')}>Il tuo profilo <ArrowForwardIosIcon /></p>
            </div>
        </div>
    )
}

export default HeaderNav
